<template>
  <footer-navigation :links="links"/>
</template>

<script>
import { mapState } from 'vuex'
import { routes } from '@/router'
import FooterNavigation from '@/containers/FooterNavigation/FooterNavigation'

export default {
  components: {
    FooterNavigation
  },
  computed: {
    ...mapState({
      locale: state => state.i18n.locale
    }),
    links () {
      return routes
        .filter(route => route.name !== this.$route.name && route.meta && route.meta.title)
        .slice(0, 2)
        .map(link => ({
          label: link.meta.title,
          to: { name: link.name, params: { locale: this.locale } }
        }))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/FooterNavigation/FooterNavigationContainer.vue